// Analytics service for comprehensive tracking
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

export class AnalyticsService {
  private static instance: AnalyticsService;
  private isInitialized = false;

  private constructor() {}

  public static getInstance(): AnalyticsService {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  public initialize(gaId: string) {
    if (this.isInitialized) return;
    
    // Update the GA ID in the script
    const script = document.querySelector('script[src*="googletagmanager.com"]') as HTMLScriptElement;
    if (script) {
      script.src = script.src.replace('G-8TJEKY641J', gaId);
    }
    
    // Update the config
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', gaId);
    }
    
    this.isInitialized = true;
  }

  // Page view tracking
  public trackPageView(pagePath: string, pageTitle?: string) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-8TJEKY641J', {
        page_path: pagePath,
        page_title: pageTitle || document.title
      });
    }
  }

  // Custom event tracking
  public trackEvent(eventName: string, parameters?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters);
    }
  }

  // Form submission tracking
  public trackFormSubmission(formName: string, success: boolean = true) {
    this.trackEvent('form_submit', {
      form_name: formName,
      success: success,
      event_category: 'engagement',
      event_label: formName
    });
  }

  // reCAPTCHA tracking
  public trackRecaptcha(action: 'started' | 'completed' | 'failed') {
    this.trackEvent('recaptcha_interaction', {
      action: action,
      event_category: 'security',
      event_label: 'reCAPTCHA'
    });
  }

  // Review submission tracking
  public trackReviewSubmission(doctorId: string, rating: number, success: boolean) {
    this.trackEvent('review_submit', {
      doctor_id: doctorId,
      rating: rating,
      success: success,
      event_category: 'engagement',
      event_label: 'doctor_review'
    });
  }

  // User engagement tracking
  public trackEngagement(action: string, element: string) {
    this.trackEvent('user_engagement', {
      action: action,
      element: element,
      event_category: 'engagement'
    });
  }

  // Error tracking
  public trackError(error: string, fatal: boolean = false) {
    this.trackEvent('exception', {
      description: error,
      fatal: fatal,
      event_category: 'error'
    });
  }

  // Conversion tracking
  public trackConversion(conversionType: string, value?: number) {
    this.trackEvent('conversion', {
      conversion_type: conversionType,
      value: value,
      event_category: 'conversion'
    });
  }
}

export const analytics = AnalyticsService.getInstance();
